import type { EMetricKey } from '~/types/metric';

import { LISTING_METRIC_DEFAULT_SELECTION, LISTING_METRIC_ORDER } from '../constants';
import { createPersistedStoreWithShopId } from '~/utils/createPersistedStore';

export interface IMetricsSelectorStoreState {
  selectedMetrics: EMetricKey[];
  metricsOrder: EMetricKey[];
  setSelectedMetrics: (selectedMetrics: EMetricKey[]) => void;
  setMetricsOrder: (metricsOrder: EMetricKey[]) => void;
}

export const useMetricsSelectorStore = createPersistedStoreWithShopId<IMetricsSelectorStoreState>(
  'page-analytic-metrics-config',
  (set) => ({
    selectedMetrics: LISTING_METRIC_DEFAULT_SELECTION,
    metricsOrder: LISTING_METRIC_ORDER,
    setMetricsOrder: (metricsOrder) => set({ metricsOrder }),
    setSelectedMetrics: (selectedMetrics) => set({ selectedMetrics }),
  }),
);
